import { render, staticRenderFns } from "./layout-cooperation.vue?vue&type=template&id=e4cff09c"
import script from "./layout-cooperation.vue?vue&type=script&lang=js"
export * from "./layout-cooperation.vue?vue&type=script&lang=js"
import style0 from "./layout-cooperation.vue?vue&type=style&index=0&id=e4cff09c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports